module.exports = __webpack_public_path__ + "static/media/red_time_of_day.8022bea1.svg";